import { Button, Collapse, Grid, makeStyles, Theme, Typography, useTheme } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

import * as Sentry from "@sentry/react";
import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    alertMessage: {
        width: '100%'
    },
    alertRoot: {
        margin: (theme: Theme) => theme.spacing(2),
        borderRadius: (theme: Theme) => theme.spacing(1)
    }
});

const RouteErrorBoundary : Sentry.FallbackRender = ({
    error
}) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const [details, setDetails] = useState(false);
    
    return (
        <>
            <Alert
                severity="error"
                classes={{ message: classes.alertMessage, root: classes.alertRoot,  }}
            >
                <AlertTitle>An error has occurred!</AlertTitle>
                <Typography gutterBottom>
                    Please refresh the page and try again.
                </Typography>
                {
                    (error as any)?.message && (
                        <Typography gutterBottom>
                            <strong>Error:</strong> <em>{(error as any).message}</em>
                        </Typography>
                    )
                }
                <Grid
                    container
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    }}
                    spacing={2}
                >
                    <Grid item>
                        {
                            (error as any)?.stack && (
                                <>
                                    <Button onClick={() => setDetails(c => !c)}>
                                        More Details
                                    </Button>
                                </>
                            )
                        }
                    </Grid>
                    <Grid item>
                        <Button
                            component={Link}
                            to={"/"}
                            variant="contained"
                        >
                            Home
                        </Button>
                    </Grid>
                </Grid>
                {
                    (error as any)?.stack && (
                        <Collapse in={details}>
                            <pre>
                                {(error as any).stack}
                            </pre>
                        </Collapse>
                    )
                }
            </Alert>
        </>
    );
}
export default RouteErrorBoundary;